import React, { HTMLAttributes } from 'react';
import { MdCall, MdCallMade } from 'react-icons/md';
import * as styles from '../../styles/icons/callIcon.module.scss';
import CombinedIconTopRight from './CombinedIconTopRight';

const OutboundCall: React.FC<HTMLAttributes<HTMLSpanElement>> = (props) => (
  <CombinedIconTopRight
    MainIcon={MdCall}
    SmallIcon={MdCallMade}
    colorSmall='red'
    className={styles.nudge_2}
    {...props}
  />
);

export default OutboundCall;
